import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e25e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-header" }, [
  /*#__PURE__*/_createTextVNode(" Checkout "),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_3 = { class: "panels" }
const _hoisted_4 = { class: "details-panel" }
const _hoisted_5 = { class: "order-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_UserInfoPanel = _resolveComponent("UserInfoPanel")!
  const _component_OrderDetails = _resolveComponent("OrderDetails")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UserInfoPanel, {
            onSubmit: _ctx.onSubmit,
            onPostcodeSelected: _ctx.postcodeSelected,
            loading: _ctx.loading
          }, null, 8, ["onSubmit", "onPostcodeSelected", "loading"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_OrderDetails, { onEditDesign: _ctx.editDesign }, null, 8, ["onEditDesign"])
        ])
      ]),
      _createVNode(_component_Toast)
    ])
  ], 64))
}